import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import RouterComponent from "./RouterComponent";

const App = () => (
  <Router>
    <RouterComponent />
  </Router>
);

export default App;
